module.exports = __webpack_public_path__ + "static/media/seat-wifi.1dd6189c.svg";